<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="12" md="4" lg="2">
          <v-select
            outlined
            flat
            dense
            background-color="white"
            v-model="selectedYear"
            :items="yearOptions"
            label="Year"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="2">
          <v-select
            outlined
            flat
            dense
            background-color="white"
            v-model="selectedMonth"
            :items="monthOptions"
            item-text="label"
            item-value="value"
            label="Month"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="2">
          <v-btn color="primary" @click="search" class="mr-2">
            <v-icon>
              mdi-magnify
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="items"
        :search="filter"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        dense
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row class="mt-2">
              <v-col cols="12" sm="12" md="8" lg="8">
                <v-text-field
                  flat
                  dense
                  outlined
                  background-color="white"
                  v-model="filter"
                  placeholder="search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:item.no="{ index }">
          {{ (page - 1) * itemsPerPage + index + 1 }}
        </template>
        <template v-slot:item.description="{ item }">
          {{ item.fixedAsset ? item.fixedAsset.description : "-" }}
        </template>
        <template v-slot:item.category="{ item }">
          {{ item.fixedAsset ? item.fixedAsset.category : "-" }}
        </template>
        <template v-slot:item.journalId="{ item }">
          <span
            v-if="item.journal && item.journal.id"
            @click="toFormJournal(item.journal.id)"
            class="journal-link"
          >
            {{ item.journal.id }}
          </span>
          <span v-else>-</span>
        </template>
        <template v-slot:item.depreciationAmount="{ item }">
          {{ formatPrice(item.depreciationAmount) }}
        </template>
        <template v-slot:item.remainAmount="{ item }">
          {{ formatPrice(item.remainAmount) }}
        </template>
        <template v-slot:item.yearMonth="{ item }">
          {{ item.year }}-{{ String(item.month).padStart(2, "0") }}
        </template>
        <template v-slot:item.type="{ item }">
          <v-chip :color="item.type === 'MANUAL' ? 'primary' : 'success'" small>
            {{ item.type }}
          </v-chip>
        </template>
        <template v-slot:item.createdAt="{ item }">
          {{ formatDate(item.createdAt) }}
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "depreciation-history",
  data() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    return {
      selectedYear: currentYear,
      selectedMonth: currentMonth > 1 ? currentMonth - 1 : 1,
      yearOptions: [],
      allMonthOptions: [
        { label: "January", value: 1 },
        { label: "February", value: 2 },
        { label: "March", value: 3 },
        { label: "April", value: 4 },
        { label: "May", value: 5 },
        { label: "June", value: 6 },
        { label: "July", value: 7 },
        { label: "August", value: 8 },
        { label: "September", value: 9 },
        { label: "October", value: 10 },
        { label: "November", value: 11 },
        { label: "December", value: 12 },
      ],
      items: [],
      filter: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: "No", value: "no", width: "80px", sortable: false },
        { text: "Description", value: "description", width: "300px" },
        { text: "Category", value: "category" },
        { text: "Journal ID", value: "journalId" },
        { text: "Depreciation Amount", value: "depreciationAmount", align: "right" },
        { text: "Remain Amount", value: "remainAmount", align: "right" },
        { text: "Period", value: "yearMonth" },
        { text: "Type", value: "type" },
        { text: "Created At", value: "createdAt" },
        { text: "Created By", value: "createdBy" },
      ],
    };
  },
  computed: {
    monthOptions() {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;

      // If selected year is current year, limit to current month - 1
      if (this.selectedYear === currentYear) {
        const maxMonth = currentMonth - 1;
        return this.allMonthOptions.filter(month => month.value <= maxMonth);
      }

      // For previous years, show all months
      return this.allMonthOptions;
    },
  },
  methods: {
    async search() {
      this.$store.commit("SET_LOADER", true);
      try {
        const response = await this.$store.dispatch("fixedAsset/depreciationHistory", {
          year: this.selectedYear,
          month: this.selectedMonth,
        });
        if (response.status === 200) {
          this.items = response.data;
          this.$store.dispatch("toast", {
            type: "success",
            message: "Data loaded successfully",
          });
        }
      } catch (error) {
        this.$store.dispatch("toast", {
          type: "error",
          message: "Failed to load data",
        });
      } finally {
        this.$store.commit("SET_LOADER", false);
      }
    },
    formatPrice(value) {
      if (!value) return "0";
      return new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    formatDate(timestamp) {
      if (!timestamp) return "-";
      const date = new Date(timestamp);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}-${month}-${year} ${hours}:${minutes}`;
    },
    generateYearOptions() {
      const currentYear = new Date().getFullYear();
      this.yearOptions = [];
      for (let i = currentYear - 2; i <= currentYear; i++) {
        this.yearOptions.push(i);
      }
    },
    toFormJournal(id) {
      const routeData = this.$router.resolve({ name: "Detail Journal", params: { id: id } });
      window.open(routeData.href, "_blank");
    },
  },
  mounted() {
    this.generateYearOptions();
  },
};
</script>

<style scoped>
.journal-link {
  color: #1976d2;
  cursor: pointer;
  text-decoration: underline;
}

.journal-link:hover {
  color: #1565c0;
}
</style>
